import { __assign, __awaiter, __extends, __generator, __read } from "tslib";
import { AppbarConnectorService } from '@office-start/appbar-connector-service';
import { queryCache } from '@office-start/data-fetching';
import { fetchMyDriveRootUrls } from '@office-start/graph-service';
import { IDLE_VERYLOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { SearchHostAppLogger } from '../host-app-logger/SearchHostAppLogger';
import { getSearchCenterUrl } from '../search-center-url/getSearchCenterUrl';
import { getHostAppSettings, } from '../settings';
import { fetchMiddleTierSearchConfiguration } from '../utils';
import { runPrefetchCalls } from '../warmup';
import { Module, SearchDispatcher, } from '.';
import { ModuleError } from './ModuleError';
export var appbarConnectorService = AppbarConnectorService.getInstance();
var SearchMainModule = /** @class */ (function (_super) {
    __extends(SearchMainModule, _super);
    function SearchMainModule(_a) {
        var searchSettings = _a.searchSettings, searchModules = _a.searchModules, searchPrefetch = _a.searchPrefetch, searchInstrumenter = _a.searchInstrumenter, userProfile = _a.userProfile;
        var _this = _super.call(this, 'Search_Main_Module') || this;
        _this.isMainModuleInitialized = false;
        _this.emptyLogEventBuffer = false;
        _this.searchSettings = searchSettings;
        _this.searchModules = searchModules;
        _this.searchPrefetch = searchPrefetch;
        _this.searchInstrumenter = searchInstrumenter;
        _this.searchHostAppLogger = new SearchHostAppLogger();
        _this.searchDispatcher = new SearchDispatcher(searchSettings, searchModules, _this.searchHostAppLogger);
        _this.userProfile = userProfile;
        _this.initialize();
        return _this;
    }
    SearchMainModule.prototype.initializeMainModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, searchInstrumenter, searchPrefetch, searchDispatcher, searchMainModule, tokenProviders, identity, officeContext, searchConfig, hostAppId, searchMiddleTierEnvironment, userRing, hostAppSettings, searchCenterUrl, userEntitlements, sharePointResourceId, searchConfiguration, _b, _1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.isMainModuleInitialized) {
                            return [2 /*return*/, this.module.data];
                        }
                        return [4 /*yield*/, Promise.all([
                                this.searchInstrumenter.getModule(),
                                this.searchPrefetch.getModule(),
                                this.searchDispatcher.getModule(),
                                this.getModule(),
                                this.searchSettings.getTokenProviders(),
                                this.searchSettings.getIdentity(),
                                this.searchSettings.getOfficeComponentContext(),
                                this.searchSettings.getSearchConfig(),
                                this.searchSettings.getHostAppId(),
                                this.searchSettings.getSearchMiddleTierEnvironment(),
                                this.searchSettings.getRing(),
                                getHostAppSettings(this.searchInstrumenter, this.searchSettings),
                                getSearchCenterUrl(this.searchPrefetch, this.searchSettings, this.searchHostAppLogger),
                                this.searchSettings.getUserEntitlements(),
                                this.runPrefetchCalls(),
                            ])];
                    case 1:
                        _a = __read.apply(void 0, [_c.sent(), 14]), searchInstrumenter = _a[0], searchPrefetch = _a[1], searchDispatcher = _a[2], searchMainModule = _a[3], tokenProviders = _a[4], identity = _a[5], officeContext = _a[6], searchConfig = _a[7], hostAppId = _a[8], searchMiddleTierEnvironment = _a[9], userRing = _a[10], hostAppSettings = _a[11], searchCenterUrl = _a[12], userEntitlements = _a[13];
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 6, , 7]);
                        searchMainModule.conf.sets('searchux.api.sharePointSearchCenter.url', searchCenterUrl);
                        sharePointResourceId = (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.SharePointResourceId) || '';
                        if (!!identity.isMsa) return [3 /*break*/, 4];
                        return [4 /*yield*/, fetchMiddleTierSearchConfiguration({
                                searchInstrumenter: searchInstrumenter,
                                searchPrefetch: searchPrefetch,
                                tokenProviders: tokenProviders,
                                searchMiddleTierEnvironment: searchMiddleTierEnvironment,
                                searchConfig: searchConfig,
                                sharePointResourceId: sharePointResourceId,
                                searchCenterUrl: searchCenterUrl,
                            })];
                    case 3:
                        _b = _c.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _b = undefined;
                        _c.label = 5;
                    case 5:
                        searchConfiguration = _b;
                        this.initializeLoggingModule(searchMainModule, searchDispatcher, searchInstrumenter, {
                            hostAppId: hostAppId,
                            puid: identity.puid,
                            tenantId: identity.tenantId,
                            userRing: userRing,
                            inMockMode: officeContext.inMockMode,
                            searchConfiguration: searchConfiguration,
                            tokenProviders: tokenProviders,
                        });
                        this.initializeSearchMainModule({
                            main: searchMainModule,
                            prefetch: searchPrefetch,
                            searchConfiguration: searchConfiguration,
                            hostAppSettings: hostAppSettings,
                            searchConfig: searchConfig,
                        });
                        this.isMainModuleInitialized = true;
                        return [2 /*return*/, searchMainModule];
                    case 6:
                        _1 = _c.sent();
                        throw new ModuleError('Search_Main_Module', 'Initialization_Error');
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    SearchMainModule.prototype.getSearchHostAppLogger = function () {
        return this.searchHostAppLogger;
    };
    SearchMainModule.prototype.initializeModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, searchModules, officeContext, cdnOptions, searchStrings, stringMapLoader, _b, mainModule, isTestEnv, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.searchModules.getModule(),
                            this.searchSettings.getOfficeComponentContext(),
                            this.searchSettings.getCdnOptions(),
                        ])];
                    case 1:
                        _a = __read.apply(void 0, [_e.sent(), 3]), searchModules = _a[0], officeContext = _a[1], cdnOptions = _a[2];
                        return [4 /*yield*/, searchModules.loadStrings()];
                    case 2:
                        searchStrings = _e.sent();
                        stringMapLoader = searchStrings.getStringMapLoader(officeContext.preferredCulture, cdnOptions);
                        return [4 /*yield*/, Promise.all([
                                this.fetchModule(),
                                this.searchSettings.getIsTestEnv(),
                            ])];
                    case 3:
                        _b = __read.apply(void 0, [_e.sent(), 2]), mainModule = _b[0], isTestEnv = _b[1];
                        if (!!isTestEnv) return [3 /*break*/, 6];
                        _d = (_c = mainModule).loadStrings;
                        return [4 /*yield*/, stringMapLoader];
                    case 4: return [4 /*yield*/, _d.apply(_c, [_e.sent(), officeContext.preferredCulture])];
                    case 5:
                        _e.sent();
                        _e.label = 6;
                    case 6:
                        this.module.resolve(mainModule);
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchMainModule.prototype.preloadSearchIfEligible = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, identity, searchConfig, metrics, metricName, metricEntry, currentYear, yearLastUsedSearch;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.searchSettings.getIdentity(),
                            this.searchSettings.getSearchConfig(),
                        ])];
                    case 1:
                        _a = __read.apply(void 0, [_b.sent(), 2]), identity = _a[0], searchConfig = _a[1];
                        if (identity.isMsa && searchConfig.disableSearchEnterPressedAction) {
                            return [2 /*return*/];
                        }
                        metrics = this.userProfile && this.userProfile.metrics;
                        for (metricName in metrics) {
                            // Look at user behaviors we have logged
                            if (metricName.toLowerCase().indexOf('search') !== -1) {
                                metricEntry = metrics[metricName];
                                if (metricEntry) {
                                    currentYear = new Date().getFullYear();
                                    yearLastUsedSearch = new Date(metricEntry.lastOccurrence).getFullYear();
                                    // If they have used search in the last year, load the FAST main module.
                                    if (currentYear - yearLastUsedSearch <= 1) {
                                        if ('requestIdleCallback' in window) {
                                            // queues the work; to be called when the browser is idle
                                            requestIdleCallback(function () {
                                                _this.initializeMainModule();
                                            });
                                        }
                                        else {
                                            // fallback to setTimeout for safari which doesn't support requestIdleCallback
                                            setTimeout(function () {
                                                _this.initializeMainModule();
                                            });
                                        }
                                        return [2 /*return*/];
                                    }
                                }
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchMainModule.prototype.initialize = function () {
        var _this = this;
        if (appbarConnectorService.getIsCopilotChatExperience()) {
            scheduleWork(function () { return _this.preloadSearchIfEligible(); }, IDLE_VERYLOW_PRIORITY);
        }
        else {
            this.preloadSearchIfEligible();
        }
    };
    SearchMainModule.prototype.runPrefetchCalls = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                runPrefetchCalls({
                    searchPrefetch: this.searchPrefetch,
                    searchInstrumenter: this.searchInstrumenter,
                    searchSettings: this.searchSettings,
                    searchDispatcher: this.searchDispatcher,
                    searchHostAppLogger: this.searchHostAppLogger,
                });
                return [2 /*return*/];
            });
        });
    };
    SearchMainModule.prototype.fetchModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, searchPrefetch, searchModules, query;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.searchPrefetch.getModule(),
                            this.searchModules.getModule(),
                        ])];
                    case 1:
                        _a = __read.apply(void 0, [_b.sent(), 2]), searchPrefetch = _a[0], searchModules = _a[1];
                        query = ['SearchMainModule'];
                        return [2 /*return*/, queryCache.fetchQuery(query, function () {
                                return searchPrefetch.withBasicMonitor({
                                    monitorName: 'main_module_load',
                                    monitorType: 'generic_qos',
                                }, function () { return searchModules.loadMain(); })();
                            }, {
                                cacheTime: Infinity,
                                staleTime: Infinity,
                                onError: function () {
                                    throw new ModuleError('Search_Main_Module', 'Fetching_Error');
                                },
                            })];
                }
            });
        });
    };
    SearchMainModule.prototype.initializeLoggingModule = function (mainModule, searchDispatcher, instrumenter, options) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        var userRing = options.userRing, inMockMode = options.inMockMode, puid = options.puid, hostAppId = options.hostAppId, tenantId = options.tenantId;
        var hostComponentInfo = {
            environment: undefined,
            id: undefined,
            version: undefined,
            userRing: userRing,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        };
        var dispatcher = searchDispatcher.getDispatcher();
        var test1dsLogger = Boolean((_b = (_a = options.searchConfiguration) === null || _a === void 0 ? void 0 : _a.ecsSettings) === null || _b === void 0 ? void 0 : _b['searchux.test1dsLogger']);
        var compare1dsLogger = Boolean((_d = (_c = options.searchConfiguration) === null || _c === void 0 ? void 0 : _c.ecsSettings) === null || _d === void 0 ? void 0 : _d['searchux.compare1dsLogger']);
        var getBufferedLogEvents = function () {
            var buffer = _this.searchDispatcher.copyLogEventBuffer();
            if (_this.emptyLogEventBuffer) {
                _this.searchDispatcher.cleanLogEventBuffer();
                dispatcher.unregister(_this.searchDispatcher.getLogEventBufferUnregisterToken());
            }
            _this.emptyLogEventBuffer = true;
            return buffer;
        };
        var hostAndTenantInfo = {
            hostAppInfo: {
                id: hostAppId,
                version: '',
                userRing: userRing,
            },
            tenantInfo: {
                omsId: tenantId,
            },
        };
        var loggerProps = {
            dispatcher: dispatcher,
            instrumenter: instrumenter,
            getBufferedLogEvents: getBufferedLogEvents,
            logCtx: __assign(__assign({ appInfo: {
                    id: '@1js/search-page',
                    component: 'serp',
                }, userInfo: {
                    id: puid,
                    // We have never sent in searchConfiguration here prior to the EUDB changes,
                    // so we don`t require to log userFlights.
                    flights: [],
                } }, hostAndTenantInfo), { hostComponentInfo: hostComponentInfo, spInfo: {
                    siteSubscriptionId: '', // Required by interface
                } }),
            disableCookies: true,
        };
        if (!inMockMode) {
            if (test1dsLogger) {
                mainModule.enable1dsLogger(loggerProps);
            }
            else {
                compare1dsLogger && mainModule.enable1dsLogger(loggerProps);
                mainModule.enableAriaLogger(loggerProps);
            }
            var useEventsLogger = Boolean((_f = (_e = options.searchConfiguration) === null || _e === void 0 ? void 0 : _e.ecsSettings) === null || _f === void 0 ? void 0 : _f['searchux.enable3SEventsLogging']);
            if (useEventsLogger) {
                (_g = mainModule.enable3SEventsLogger) === null || _g === void 0 ? void 0 : _g.call(mainModule, {
                    dispatcher: dispatcher,
                    instrumenter: instrumenter,
                    getBufferedLogEvents: getBufferedLogEvents,
                    logCtx: __assign({ userInfo: {
                            id: puid,
                        } }, hostAndTenantInfo),
                    tokenProvider: options.tokenProviders.substrateTokenProvider,
                });
            }
        }
    };
    SearchMainModule.prototype.initializeSearchMainModule = function (_a) {
        var main = _a.main, prefetch = _a.prefetch, searchConfiguration = _a.searchConfiguration, hostAppSettings = _a.hostAppSettings, searchConfig = _a.searchConfig;
        var config = hostAppSettings;
        if (searchConfiguration &&
            searchConfiguration.ecsSettings &&
            searchConfiguration.ecsSettings.useEcsSettings) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var ecsConfig = __assign({}, searchConfiguration.ecsSettings);
            var relevantConfigIds = prefetch.getEcsIds(searchConfiguration.ecsConfigIds);
            var flights3s = config['searchux.substrateSearchClientFlights'];
            var relatedPeopleFlights = [
                ecsConfig['searchux.isRelatedPeopleEnabled'] &&
                    ecsConfig['searchux.relatedPeopleClientFlight'],
            ].filter(Boolean);
            /**
             * Loki is the old Search middle tier.
             * Thor is the new Search middle tier replacing Loki.
             */
            config = __assign(__assign(__assign(__assign(__assign({}, config), { 'searchux.api.loki.url': searchConfiguration.lokiUrl, 'searchux.userAadObjectId': searchConfiguration.userAadObjectId, 'searchux.tenantAadObjectId': searchConfiguration.tenantAadObjectId }), (relevantConfigIds && {
                'searchux.ecsConfigIds': relevantConfigIds,
            })), ecsConfig), { 'searchux.substrateSearchClientFlights': flights3s
                    ? flights3s
                        .split(',')
                        .concat(relatedPeopleFlights)
                        .join(',')
                    : relatedPeopleFlights.join(','), 'searchux.useThor': searchConfig.useThorEnabled });
        }
        main.conf.setsFromObject(config);
        this.setOneDriveUrl(main);
        main.exposeDebugInterface('mssearchux.officeHome', {
            version: main.version,
            conf: main.conf,
            ecsConfig: searchConfiguration,
        });
    };
    SearchMainModule.prototype.setOneDriveUrl = function (main) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var rootUrls, userRoot;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetchMyDriveRootUrls()];
                    case 1:
                        rootUrls = _b.sent();
                        userRoot = rootUrls && ((_a = rootUrls.result) === null || _a === void 0 ? void 0 : _a.userRoot);
                        if (userRoot) {
                            main.conf.sets('searchux.personalUrl', userRoot);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return SearchMainModule;
}(Module));
export { SearchMainModule };
//# sourceMappingURL=SearchMainModule.js.map